import { PaginationRequest } from "../config/common";
import { Customer, Consignment } from "src/@core/models";

export interface CustomerInvoice {
	customerID: string;
	customerName: string;
	invoiceStatus: string;
	invoiceModels: InvoiceModel[];
}

export enum InvoiceStateType {
	AwaitingInvoice = 0,
	Accepted = 1,
	Authorised = 2,
	Submitted = 3,
	Paid = 4,
	PartiallyPaid = 5
}

export enum InvoiceStatusType {
	Emailed = 0,
	Printed = 1,
	SelfBilled = 2
}

export interface InvoiceModel {

	id: string;
	consignmentNumber: number;
	poNumber: string;
	fromDate: Date;
	toDate?: Date;
	createOn: Date;
	collectionDate: Date;
	costPrice: number;
	sellingPrice: number;
	invoiceChecked: boolean;
	dateTimeDelivered: Date;
	exceptionCode: string;
	failedDeliveryCharges: number;
	invoiceState: InvoiceStateType;
	invoiceLegend: number;
	invoiceStatus: number;
  xeroInvoiceID: string;
  xeroInvoiceNumber: string;
	invoiceNumber: number;
	consignment: Consignment;
	linkedInvoiceId?: string;

}


export interface RequestCustomerInvoice {
	customerID?: string;
	dateFrom?: string;
	dateTo?: string;
	searchInvoiceGroup?: boolean;
	branchID?: string;
	consignmentRef?: number;
	invoiceState?: number;
}
